
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15" fill="currentColor">
  <path d="M2.625 12.75L12.25 12.75V11.875L1.75 11.875V12.75H2.625ZM11.2467 6.49667L10.6283 5.87833L7.4375 9.06917V2.25H6.5625V9.06917L3.37167 5.87833L2.75333 6.49667L7 10.7433L11.2467 6.49667Z"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'DownloadSimple',
    }) as DefineComponent
    </script>
    